<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 22H5V9h14zM7 20h10v-9H7z"/><path d="M17 10h-2V7a3 3 0 00-6 0v3H7V7a5 5 0 0110 0z"/><circle cx="12" cy="14.5" r="2"/><path d="M11 15.5h2v3h-2z"/></svg>